import { useState } from "react";
import userImg from '../Img/Login-img.jpg';
import ordersIcon from '../Img/003-order.png';
import addressIcon from '../Img/001-locations.png';
import trackOrderIcon from '../Img/002-tracking.png';
import helpIcon from '../Img/004-customer-care.png';
import Address from "./Address";
import OrderCard from "./Orders";
import HelpUs from "./HelpUs";
import { useNavigate } from "react-router-dom";
import decryptCookieData from "./Functions/decryptCookieData";
import user from "../Img/userdummy.png"

const MyAccount = ({ cartButtons }) => {
    const [activeTab, setActiveTab] = useState("Orders");
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null;
    const url = process.env.REACT_APP_API_URL

    const getDefaultCartButton = () => {
        const isGetQuoteDefault = cartButtons.find(b => b.button_id === 'getquote' && b.default);
        if (isGetQuoteDefault) return 'getquote';

        const isAddToCartDefault = cartButtons.find(b => b.button_id === 'addtocart' && b.default);
        if (isAddToCartDefault) return 'addtocart';

        const isBuyNowDefault = cartButtons.find(b => b.button_id === 'buynow' && b.default);
        if (isBuyNowDefault) return 'buynow';

        return null; // fallback
    };
    const defaultButton = getDefaultCartButton();

    const tabData = [
        { name: "Orders", icon: ordersIcon, content: <OrdersContent /> },
        ...(defaultButton !== 'getquote'
            ? [{ name: "Address", icon: addressIcon, content: <AddressContent /> }]
            : []),
        { name: "Help", icon: helpIcon, content: <HelpContent /> }
    ];

    const navigate = useNavigate();

    const handlelogout = async () => {
        try {
            // Send logout request to backend to clear cookies
            // await fetch(`${url}/loginuser/logout`, {
            //     method: "POST",
            //     credentials: "include", // ✅ ensures cookies are sent
            // });

            localStorage.removeItem("2xgxgshdugyywerw12");
            localStorage.removeItem("2xgxgshdugyywerw12gh");
            // Optional: redirect or reload
            navigate("/login")
            // window.location.href = "/login"; // Or navigate to login
        } catch (err) {
            console.error("Logout failed:", err);
        }
    };

    return (
        <div className="my-account-perfume">
            <div className="my-account-container-perfume">
                <div className="my-account-header-perfume">
                    <h2>My Account</h2>
                    <div className="my-account-header-detail-logout">
                        <div className="my-account-header-img-detail">
                            <img src={user} alt="User" className="user-img" />
                            <div className="my-account-header-details">
                                <p className='my-account-user-name'>{userData.full_name}</p>
                                <p className='my-account-user-email'>{userData.email}</p>
                            </div>
                        </div>
                        <div className="my-account-header-logout-btn" onClick={handlelogout}>
                            <button className="logout-btn"  >Logout</button>
                        </div>
                    </div>
                </div>
                <div className="my-account-tabs-perfume">
                    <div className="my-account-tabs">
                        {tabData.map((tab) => (
                            <div
                                key={tab.name}
                                className={`my-account-tabs-item ${activeTab === tab.name ? 'active-tab' : ''}`}
                                onClick={() => setActiveTab(tab.name)}
                            >
                                <img src={tab.icon} alt={tab.name} className="tab-icon" />
                                <p>{tab.name}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="my-account-tab-content">
                    {tabData.find((tab) => tab.name === activeTab)?.content}
                </div>
            </div>
        </div>
    );
};

// Components for each tab's content
const OrdersContent = () => (
    <div className="tab-content">
        <h3>Your Orders</h3>
        <OrderCard />
    </div>
);

const AddressContent = () => {
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null;
    const [data, setData] = useState({
        location_user: "",
        new_address: "",
        city: "",
        pincode: "",
        user_id: userData.user_id,
        user_name: userData.full_name,
    })
    const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);
    const [selectedBillingAddress, setSelectedBillingAddress] = useState(null);
    return <div className="tab-content">
        <h3>Address</h3>
        <Address data={data} setData={setData} selectedBillingAddress={selectedBillingAddress} setSelectedShippingAddress={setSelectedShippingAddress} setSelectedBillingAddress={setSelectedBillingAddress} selectedShippingAddress={selectedShippingAddress} />
    </div>
};

const HelpContent = () => (
    <div className="tab-content">
        <h3>Need assistance? Connect with us instantly.</h3>
        <HelpUs />
    </div>
);

export default MyAccount;
